import script from "./project-dialog.vue?vue&type=script&lang=ts&setup=true&name=ProjectDialog"
export * from "./project-dialog.vue?vue&type=script&lang=ts&setup=true&name=ProjectDialog"

const __exports__ = script;

export default __exports__